import styles from "./ShowroomEntries.css.ts";
import { ShowroomEntryPreview } from "./components/ShowroomEntryPreview/ShowroomEntryPreview.jsx";

export const ShowroomEntries = ({
  entries,
  workshopSettings,
  unseenByEntryId = [],
  isPublic = false,
}) => {
  return (
    <div className={styles.wrapper}>
      {entries.map((entry) => (
        <ShowroomEntryPreview
          key={entry.id}
          entry={entry}
          to={entry.smallTeamId}
          unseenCount={unseenByEntryId[entry.id] || 0}
          workshopSettings={workshopSettings}
          isPublic={isPublic}
        />
      ))}
    </div>
  );
};
